import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import { ErrorBoundary } from "./app/ErrorBoundary";
import { installErrorReporting } from "./lib/errors";
import { installUsageTracking } from "./lib/usage";
import "./styles.css";

installErrorReporting();
installUsageTracking();
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
